import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_protected/settings/admin/audience/$sqid/$",
)({
  beforeLoad: ({ params, location }) => {
    redirect({
      to: "/settings/admin/audience/$sqid/info",
      params: { sqid: params.sqid },
      replace: true,
      search: true,
      hash: true,
      state: location.state,
      throw: true,
    });
  },
});
